import axios from "axios";
// var path = "http://bbtecdemo.onthewifi.com";

let path = "";

if (process.env.NODE_ENV === `development`) {
    path = "";
}
else{
    //var path = "http://bbtecdemo.onthewifi.com";
    path = "http://192.168.10.5";
}

export function GetJobCategory(params) {
    return async (dispatch) => {
        function onSuccess(success) {
            dispatch({ type: "GET_JOB_CATEGORY" });
            return success;
        }
        function onError(error) {
            dispatch({ type: "ERROR" });
            return error;
        }
        try {
            const success = await axios.get(
                path + "/maxioperationapi/api/get_job_category" + params
            );
            return onSuccess(success);
        } catch (error) {
            return onError(error);
        }
    };
}

export function GetEmployee(params) {
    return async (dispatch) => {
        function onSuccess(success) {
            dispatch({ type: "GET_EMPLOYEE" });
            return success;
        }
        function onError(error) {
            dispatch({ type: "ERROR" });
            return error;
        }
        try {
            const success = await axios.post(
                path + "/maxioperationapi/api/get_employee",
                params
            );
            return onSuccess(success);
        } catch (error) {
            return onError(error);
        }
    };
}

export function GetDivision(params) {
    return async dispatch => {
        function onSuccess(success) {
            dispatch({ type: "GET_DIVISION" });
            return success;
        }
        function onError(error) {
            dispatch({ type: "ERROR" });
            return error;
        }
        try {
            const success = await axios.post(path + '/maxioperationapi/api/get_division', params);
            return onSuccess(success);
        } catch (error) {
            return onError(error);
        }
    }
};

export function GetDepartment(params) {
    return async dispatch => {
        function onSuccess(success) {
            dispatch({ type: "GET_DEPARTMENT" });
            return success;
        }
        function onError(error) {
            dispatch({ type: "ERROR" });
            return error;
        }
        try {
            const success = await axios.post(path + '/maxioperationapi/api/get_department', params);
            return onSuccess(success);
        } catch (error) {
            return onError(error);
        }
    }
};

export function GetAssetGroupType(params) {
    return async dispatch => {
        function onSuccess(success) {
            dispatch({ type: "GET_ASSET_GROUP_TYPE" });
            return success;
        }
        function onError(error) {
            dispatch({ type: "ERROR" });
            return error;
        }
        try {
            const success = await axios.post(path + '/maxioperationapi/api/get_infra_asset_group_type', params);
            return onSuccess(success);
        } catch (error) {
            return onError(error);
        }
    }
};

export function GetJobStatus(params) {
    return async dispatch => {
        function onSuccess(success) {
            dispatch({ type: "GET_JOB_STATUS" });
            return success;
        }
        function onError(error) {
            dispatch({ type: "ERROR" });
            return error;
        }
        try {
            const success = await axios.post(path + '/maxioperationapi/api/get_job_progress_status', params);
            return onSuccess(success);
        } catch (error) {
            return onError(error);
        }
    }
};

export function GetJobStepStatus(params) {
    return async dispatch => {
        function onSuccess(success) {
            dispatch({ type: "GET_JOB_STEP_STATUS" });
            return success;
        }
        function onError(error) {
            dispatch({ type: "ERROR" });
            return error;
        }
        try {
            const success = await axios.post(path + '/maxioperationapi/api/get_job_progress_sequence', params);
            return onSuccess(success);
        } catch (error) {
            return onError(error);
        }
    }
};

export function GetJobType(params) {
    return async dispatch => {
        function onSuccess(success) {
            dispatch({ type: "GET_JOB_TYPE" });
            return success;
        }
        function onError(error) {
            dispatch({ type: "ERROR" });
            return error;
        }
        try {
            const success = await axios.post(path + '/maxioperationapi/api/get_job_type', params);
            return onSuccess(success);
        } catch (error) {
            return onError(error);
        }
    }
};


export function GetJobSubType(params) {
    return async dispatch => {
        function onSuccess(success) {
            dispatch({ type: "GET_JOB_SUB_TYPE" });
            return success;
        }
        function onError(error) {
            dispatch({ type: "ERROR" });
            return error;
        }
        try {
            const success = await axios.post(path + '/maxioperationapi/api/get_job_sub_type', params);
            return onSuccess(success);
        } catch (error) {
            return onError(error);
        }
    }
};

export function GetTeamAssign(params) {
    return async (dispatch) => {
        function onSuccess(success) {
            dispatch({ type: "GET_ASSIGN_TEAM" });
            return success;
        }
        function onError(error) {
            dispatch({ type: "ERROR" });
            return error;
        }
        try {
            const success = await axios.post(
                path + "/maxioperationapi/api/get_assign_job_ma",
                params
            );
            return onSuccess(success);
        } catch (error) {
            return onError(error);
        }
    };
}

export function GetPeriod(params) {
    return async (dispatch) => {
        function onSuccess(success) {
            dispatch({ type: "GET_PERIOD" });
            return success;
        }
        function onError(error) {
            dispatch({ type: "ERROR" });
            return error;
        }
        try {
            const success = await axios.post(
                path + "/maxioperationapi/api/get_ma_period",
                params
            );
            return onSuccess(success);
        } catch (error) {
            return onError(error);
        }
    };
}

export function GetAsset() {
    return async (dispatch) => {
        function onSuccess(success) {
            dispatch({ type: "GET_ASSET" });
            return success;
        }
        function onError(error) {
            dispatch({ type: "ERROR" });
            return error;
        }
        try {
            const success = await axios.get(
                path + "/maxioperationapi/api/get_cdi_new_smart"
            );
            return onSuccess(success);
        } catch (error) {
            return onError(error);
        }
    };
}

export function NewJob(params) {
    return async (dispatch) => {
        function onSuccess(success) {
            dispatch({ type: "ADD_JOB" });
            return success;
        }
        function onError(error) {
            dispatch({ type: "ERROR" });
            return error;
        }
        try {
            const success = await axios.post(
                path + "/maxioperationapi/api/update_oper_job", params
            );
            return onSuccess(success);
        } catch (error) {
            return onError(error);
        }
    };
}

export function UpdateJobCategory(params) {
    return async (dispatch) => {
        function onSuccess(success) {
            dispatch({ type: "UPDATE_JOB_CATEGORY" });
            return success;
        }
        function onError(error) {
            dispatch({ type: "ERROR" });
            return error;
        }
        try {
            const success = await axios.post(
                path + "/maxioperationapi/api/update_job_category", params
            );
            return onSuccess(success);
        } catch (error) {
            return onError(error);
        }
    };
}

export function GetTeamGroup(params) {
    return async (dispatch) => {
        function onSuccess(success) {
            dispatch({ type: "GET_TEAM_GROUP" });
            return success;
        }
        function onError(error) {
            dispatch({ type: "ERROR" });
            return error;
        }
        try {
            const success = await axios.post(
                path + "/maxioperationapi/api/get_team_group", params
            );
            return onSuccess(success);
        } catch (error) {
            return onError(error);
        }
    };
}














